export const APP_LINKS = {
  android: 'https://play.google.com/store/apps/details?id=com.parktek.app&pcampaignid=web_share',
  ios: 'https://apps.apple.com/in/app/parktek/id6760598237',
};
